<template>
    <div class="Gifabsolute">
        <img src="../../assets/gif/background.gif" alt="">
        <img src="../../assets/gif/btc.gif" alt="">
        <img src="../../assets/gif/btcecharts.gif" alt="">
        <img src="../../assets/gif/emitlight.gif" alt="">
        <img src="../../assets/gif/goldCoin.gif" alt="">
        <img src="../../assets/gif/great.gif" alt="">
        <img src="../../assets/gif/income.gif" alt="">
        <img src="../../assets/gif/lastVideo.gif" alt="">
        <img src="../../assets/gif/opendoor.gif" alt="">
        <img src="../../assets/gif/Profit1.gif" alt="">
        <img src="../../assets/gif/Profit2.gif" alt="">
        <img src="../../assets/gif/roudmap.gif" alt="">
        <img src="../../assets/gif/wealth.gif" alt="">
        <img src="../../assets/gif/zaunshi.gif" alt="">
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {

    },
    mounted() {

    },
}
</script>
<style lang="scss" scoped>
.Gifabsolute {
    position: absolute;
    z-index: -99;
    left: -9999px;
    top: -99999px;

    img {
        display: block;
        width: 100px;
        height: 100px;
    }
}
</style>


// WEBPACK FOOTER //
// src/compontents/report/Gifabsolute.vue